import dynaForms from '@elab/core/utils/dynaForms';
import { SHARED_ACTIONS } from '@elab/core/utils/constants';

const getTypes = storeName => ({
    ...dynaForms.getTypes(storeName),
    SET_METADATA: `${storeName}.SET_METADATA`,
    CHECK_PIN_CODE: `${storeName}.${SHARED_ACTIONS.checkPinCode}`,
    SET_PIN_CODE_STATUS: `${storeName}.${SHARED_ACTIONS.setPinCodeStatus}`,
    SET_IS_PIN_CODE_OR_DOB_VALID: `${storeName}.${SHARED_ACTIONS.setIsPinCodeOrDOBValid}`,
});

export default getTypes;
